var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471,238.3c-4.94,41.8-24,90.4-62.14,112.73-57.6,33.74-52.78,85.63-165.2,108.2a230.54,230.54,0,0,1-49.84,4.7,191.28,191.28,0,0,1-24.47-2c-71.44-10.44-119.53-60.1-137.17-120C9,263,55.33,211.42,86.06,180.32s53.22-128,163.56-151a224.36,224.36,0,0,1,51.23-4.86c39.26,1,82.08,13.85,111.71,40.76q3.35,3,6.5,6.27C460.24,113.72,477.74,181.31,471,238.3Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,238.3c-4.94,41.8-24,90.4-62.14,112.73-57.6,33.74-52.78,85.63-165.2,108.2a230.54,230.54,0,0,1-49.84,4.7,191.28,191.28,0,0,1-24.47-2c-71.44-10.44-119.53-60.1-137.17-120C9,263,55.33,211.42,86.06,180.32s53.22-128,163.56-151a224.36,224.36,0,0,1,51.23-4.86c39.26,1,82.08,13.85,111.71,40.76q3.35,3,6.5,6.27C460.24,113.72,477.74,181.31,471,238.3Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479,283.43H463.79a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H479a.5.5,0,0,1,.5.5A.51.51,0,0,1,479,283.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457,283.43H22.6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H457a.5.5,0,0,1,.5.5A.51.51,0,0,1,457,283.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.37,196.71h-8.7l-1.08-7.6a27.52,27.52,0,0,1-10-4.18l-6.12,4.59-6.15-6.15,4.61-6.14a27.57,27.57,0,0,1-4.12-10l-7.57-1.09v-8.69l7.6-1.09a27.48,27.48,0,0,1,4.18-10l-4.59-6.12,6.15-6.15,6.14,4.61a27.4,27.4,0,0,1,10-4.12l1.09-7.57h8.69l1.09,7.6a27.48,27.48,0,0,1,10,4.18l6.12-4.59,6.15,6.15-4.61,6.14a27.26,27.26,0,0,1,4.12,10l7.57,1.08v8.7l-7.6,1.09a27.55,27.55,0,0,1-4.18,10l4.59,6.12-6.15,6.15L421.48,185a27.43,27.43,0,0,1-10,4.12Zm-7.83-1h7l1.06-7.42.36-.07A26.57,26.57,0,0,0,421.21,184l.3-.21,6,4.52,4.92-4.93-4.5-6,.21-.29a26.61,26.61,0,0,0,4.29-10.27l.06-.35L440,165.4v-7l-7.42-1.06-.07-.36a26.35,26.35,0,0,0-4.22-10.29l-.2-.3,4.51-6-4.92-4.92-6,4.5-.3-.21a26.61,26.61,0,0,0-10.27-4.29l-.35-.06L409.65,128h-7l-1.06,7.42-.35.07a26.46,26.46,0,0,0-10.3,4.22l-.3.2-6-4.51-4.92,4.92,4.5,6-.2.3a26.46,26.46,0,0,0-4.29,10.27l-.07.35-7.45,1.07v7l7.42,1.06.07.35A26.42,26.42,0,0,0,384,177l.2.3-4.52,6,4.93,4.92,6-4.5.29.2a26.31,26.31,0,0,0,10.27,4.29l.35.07Zm3.56-14.39a19.48,19.48,0,1,1,19.48-19.48A19.5,19.5,0,0,1,406.1,181.32Zm0-37.95a18.48,18.48,0,1,0,18.48,18.47A18.49,18.49,0,0,0,406.1,143.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.76,234.77H434.3l-.78-5.46a19.89,19.89,0,0,1-7-2.94l-4.39,3.3-4.57-4.57,3.31-4.42a19.51,19.51,0,0,1-2.89-7l-5.44-.77V206.4l5.46-.78a19.74,19.74,0,0,1,2.93-7l-3.29-4.4,4.57-4.57,4.41,3.31a19.76,19.76,0,0,1,7-2.89l.78-5.44h6.46l.78,5.46a19.93,19.93,0,0,1,7,2.93l4.4-3.29,4.57,4.57-3.31,4.41a19.65,19.65,0,0,1,2.89,7l5.44.78V213l-5.46.78a19.82,19.82,0,0,1-2.93,7l3.29,4.39L453,229.75l-4.41-3.31a19.94,19.94,0,0,1-7,2.89Zm-5.6-1h4.74l.75-5.29.36-.07a18.81,18.81,0,0,0,7.3-3l.3-.2,4.29,3.22,3.34-3.35-3.2-4.27.2-.3a18.77,18.77,0,0,0,3.05-7.29l.06-.35,5.31-.76v-4.73l-5.29-.76-.06-.35a18.86,18.86,0,0,0-3-7.31l-.2-.3,3.21-4.28L453,191l-4.28,3.2-.3-.2a18.82,18.82,0,0,0-7.28-3.05l-.36-.06-.75-5.31h-4.74l-.75,5.29-.36.07a18.51,18.51,0,0,0-7.3,3l-.3.2L422.27,191l-3.34,3.35,3.2,4.27-.2.3a18.86,18.86,0,0,0-3.05,7.29l-.06.35-5.31.76V212l5.29.76.06.35a18.86,18.86,0,0,0,3,7.31l.2.29L418.85,225l3.34,3.35,4.28-3.21.29.21a18.9,18.9,0,0,0,7.29,3l.36.07Zm2.43-10a14.07,14.07,0,1,1,14.07-14.07A14.09,14.09,0,0,1,437.59,223.76Zm0-27.14a13.07,13.07,0,1,0,13.07,13.07A13.09,13.09,0,0,0,437.59,196.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.81,244.19h-8l-1-6.94a25.13,25.13,0,0,1-9.09-3.8l-5.59,4.19L72.47,232l4.2-5.61a25.36,25.36,0,0,1-3.74-9.11l-6.91-1v-8l6.94-1a25.16,25.16,0,0,1,3.8-9.08l-4.19-5.59,5.66-5.67,5.61,4.21A25.18,25.18,0,0,1,93,187.39l1-6.92h8l1,6.95a25.07,25.07,0,0,1,9.08,3.79l5.59-4.19,5.67,5.67-4.21,5.61a25.11,25.11,0,0,1,3.74,9.11l6.92,1v8l-7,1a25.11,25.11,0,0,1-3.79,9.09l4.19,5.59-5.67,5.66-5.61-4.2a25,25,0,0,1-9.11,3.74Zm-7.14-1H101l1-6.77.36-.06a24.14,24.14,0,0,0,9.38-3.85l.29-.2,5.49,4.11,4.44-4.43-4.1-5.47.2-.3a24.1,24.1,0,0,0,3.91-9.36l.07-.35,6.79-1v-6.27l-6.77-1-.07-.36a24.14,24.14,0,0,0-3.85-9.38l-.2-.29,4.12-5.49-4.44-4.44-5.47,4.1-.3-.2a24.21,24.21,0,0,0-9.35-3.91l-.35-.06-1-6.8H94.81l-1,6.77-.35.07a24.08,24.08,0,0,0-9.38,3.85l-.3.2-5.49-4.12-4.43,4.44,4.1,5.47-.21.3a24,24,0,0,0-3.9,9.35l-.07.35-6.79,1v6.28l6.77,1,.06.35a24.17,24.17,0,0,0,3.85,9.38l.2.3-4.11,5.49,4.44,4.43,5.47-4.1.29.21a24.08,24.08,0,0,0,9.36,3.9l.35.07Zm3.21-13a17.82,17.82,0,1,1,17.81-17.82A17.84,17.84,0,0,1,97.88,230.15Zm0-34.63a16.82,16.82,0,1,0,16.81,16.81A16.83,16.83,0,0,0,97.88,195.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,191.66H65.32l-.61-4.27a15.43,15.43,0,0,1-5.36-2.24l-3.44,2.58L52.22,184l2.58-3.45a15.4,15.4,0,0,1-2.2-5.37l-4.25-.61v-5.23l4.26-.61a15.63,15.63,0,0,1,2.24-5.36L52.28,160l3.69-3.7,3.45,2.59a15.47,15.47,0,0,1,5.38-2.21l.61-4.25h5.22l.61,4.27a15.43,15.43,0,0,1,5.36,2.24L80,156.33l3.69,3.7-2.58,3.45a15.62,15.62,0,0,1,2.21,5.37l4.25.61v5.22l-4.27.61a15.6,15.6,0,0,1-2.24,5.37l2.57,3.43L80,187.79l-3.45-2.59a15.67,15.67,0,0,1-5.38,2.21Zm-4.36-1h3.49l.58-4.1.36-.07a14.56,14.56,0,0,0,5.64-2.31l.3-.21,3.32,2.5L82.35,184l-2.48-3.31.2-.3a14.5,14.5,0,0,0,2.35-5.63l.07-.35,4.12-.59v-3.49l-4.11-.59-.06-.35a14.53,14.53,0,0,0-2.32-5.65l-.2-.3,2.49-3.32-2.47-2.47-3.31,2.49-.3-.21a14.44,14.44,0,0,0-5.63-2.35l-.35-.07-.59-4.11H66.27l-.58,4.1-.36.07a14.56,14.56,0,0,0-5.64,2.31l-.3.2-3.32-2.49-2.47,2.47,2.48,3.31-.2.3a14.5,14.5,0,0,0-2.35,5.63l-.07.35-4.11.59v3.49l4.1.59.06.35a14.53,14.53,0,0,0,2.32,5.65l.2.29-2.49,3.33L56,186.41l3.31-2.49.3.21a14.44,14.44,0,0,0,5.63,2.35l.35.06ZM68,183.09A11.06,11.06,0,1,1,79,172,11.08,11.08,0,0,1,68,183.09ZM68,162A10.06,10.06,0,1,0,78,172,10.08,10.08,0,0,0,68,162Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.33,120.12h-6.85l-.83-5.83a21.15,21.15,0,0,1-7.54-3.15l-4.69,3.52-4.85-4.85,3.54-4.71A20.94,20.94,0,0,1,222,97.55l-5.8-.83V89.86L222,89a21.13,21.13,0,0,1,3.14-7.54l-3.51-4.69L226.5,72l4.71,3.53a21,21,0,0,1,7.56-3.1l.83-5.81h6.85l.83,5.83a21,21,0,0,1,7.54,3.15L259.51,72l4.85,4.84-3.53,4.71a21.22,21.22,0,0,1,3.1,7.56l5.8.83v6.85l-5.83.84a21.16,21.16,0,0,1-3.14,7.53l3.52,4.7-4.85,4.84-4.71-3.53a21.08,21.08,0,0,1-7.56,3.1Zm-6-1h5.11l.81-5.66.36-.06a20.16,20.16,0,0,0,7.82-3.22l.3-.2,4.59,3.44L263,109.8l-3.42-4.57.2-.3a20.05,20.05,0,0,0,3.26-7.8l.07-.35,5.67-.81V90.85L263.08,90l-.07-.35a20.09,20.09,0,0,0-3.21-7.83l-.2-.3L263,77l-3.62-3.62-4.57,3.43-.3-.21a20.27,20.27,0,0,0-7.8-3.26l-.36-.06-.81-5.68h-5.11l-.81,5.66-.36.06a20.2,20.2,0,0,0-7.82,3.21l-.3.21-4.59-3.44L223,76.89l3.42,4.58-.2.29a20.25,20.25,0,0,0-3.26,7.81l-.07.35-5.67.81v5.12l5.65.81.07.35a20.09,20.09,0,0,0,3.21,7.83l.2.29-3.44,4.59,3.62,3.62,4.57-3.43.3.2a20,20,0,0,0,7.8,3.26l.36.07ZM243,108.35a15,15,0,1,1,15-15A15,15,0,0,1,243,108.35Zm0-29a14,14,0,1,0,14,14A14,14,0,0,0,243,79.34Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.91,90H390a8,8,0,0,1,8,8V289.41a0,0,0,0,1,0,0h-291a0,0,0,0,1,0,0V98A8,8,0,0,1,114.91,90Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,289.91h-291a.5.5,0,0,1-.5-.5V98a8.47,8.47,0,0,1,8.47-8.47H390A8.48,8.48,0,0,1,398.48,98V289.41A.5.5,0,0,1,398,289.91Zm-290.54-1h290V98A7.48,7.48,0,0,0,390,90.5H114.91A7.48,7.48,0,0,0,107.44,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.63 377.57 63.28 377.57 106.94 289.41 397.98 289.41 441.63 377.57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.63,378.07H63.28a.52.52,0,0,1-.43-.24.48.48,0,0,1,0-.48l43.66-88.16a.5.5,0,0,1,.45-.28H398a.49.49,0,0,1,.44.28l43.66,88.16a.48.48,0,0,1,0,.48A.51.51,0,0,1,441.63,378.07Zm-377.55-1H440.83l-43.16-87.16H107.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.56,
    y: 105.79,
    width: 255.78,
    height: 167.84,
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.35,274.12H124.56a.5.5,0,0,1-.5-.5V105.79a.5.5,0,0,1,.5-.5H380.35a.5.5,0,0,1,.5.5V273.62A.5.5,0,0,1,380.35,274.12Zm-255.29-1H379.85V106.29H125.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.31 317.32 240.82 306.58 225.44 306.58 224.42 317.32 240.31 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.32,317.82h-15.9a.52.52,0,0,1-.37-.16.51.51,0,0,1-.12-.39l1-10.74a.5.5,0,0,1,.5-.45h15.38a.48.48,0,0,1,.36.15.47.47,0,0,1,.14.37l-.51,10.74A.5.5,0,0,1,240.32,317.82Zm-15.35-1h14.87l.46-9.74H225.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.1 317.32 271.57 306.58 256.2 306.58 256.21 317.32 272.1 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.1,317.82H256.21a.5.5,0,0,1-.5-.5V306.58a.48.48,0,0,1,.5-.5h15.38a.49.49,0,0,1,.49.47l.53,10.74a.47.47,0,0,1-.14.37A.48.48,0,0,1,272.1,317.82Zm-15.39-1h14.86l-.47-9.74H256.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.87 328.8 371.31 328.8 367.45 317.32 351.56 317.32 354.87 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.31,329.3H354.87a.49.49,0,0,1-.48-.36l-3.31-11.48a.53.53,0,0,1,.08-.44.49.49,0,0,1,.4-.2h15.89a.51.51,0,0,1,.48.34l3.86,11.48a.54.54,0,0,1-.07.46A.5.5,0,0,1,371.31,329.3Zm-16.06-1h15.37l-3.53-10.48H352.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.42 317.32 225.44 306.58 210.06 306.58 208.53 317.32 224.42 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.42,317.82H208.53a.52.52,0,0,1-.38-.17.49.49,0,0,1-.11-.4l1.53-10.74a.49.49,0,0,1,.49-.43h15.38a.51.51,0,0,1,.37.16.48.48,0,0,1,.13.38l-1,10.75A.5.5,0,0,1,224.42,317.82Zm-15.31-1H224l.92-9.74H210.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.64 317.32 194.69 306.58 179.31 306.58 176.75 317.32 192.64 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.64,317.82H176.75a.51.51,0,0,1-.4-.19.51.51,0,0,1-.09-.43l2.56-10.74a.5.5,0,0,1,.49-.38h15.38a.48.48,0,0,1,.38.18.5.5,0,0,1,.11.41l-2.05,10.74A.49.49,0,0,1,192.64,317.82Zm-15.26-1h14.85l1.85-9.74H179.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.67 317.32 333.09 306.58 317.71 306.58 319.78 317.32 335.67 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.67,317.82H319.78a.49.49,0,0,1-.49-.41l-2.07-10.74a.49.49,0,0,1,.49-.59h15.38a.48.48,0,0,1,.48.38l2.59,10.74a.51.51,0,0,1-.1.43A.49.49,0,0,1,335.67,317.82Zm-15.48-1H335l-2.34-9.74H318.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.56 317.32 348.46 306.58 333.09 306.58 335.67 317.32 351.56 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.56,317.82H335.67a.51.51,0,0,1-.49-.38l-2.58-10.75a.52.52,0,0,1,.09-.42.51.51,0,0,1,.4-.19h15.37a.5.5,0,0,1,.49.36L352,317.18a.5.5,0,0,1-.08.44A.51.51,0,0,1,351.56,317.82Zm-15.5-1H350.9l-2.81-9.74H333.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.75 317.32 179.31 306.58 163.93 306.58 160.85 317.32 176.75 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.75,317.82h-15.9a.51.51,0,0,1-.4-.2.53.53,0,0,1-.08-.44l3.08-10.74a.49.49,0,0,1,.48-.36h15.38a.51.51,0,0,1,.39.19.49.49,0,0,1,.09.42l-2.56,10.74A.49.49,0,0,1,176.75,317.82Zm-15.23-1h14.83l2.32-9.74H164.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.99 317.32 286.95 306.58 271.57 306.58 272.1 317.32 287.99 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288,317.82H272.1a.5.5,0,0,1-.5-.48l-.52-10.74a.5.5,0,0,1,.13-.37.51.51,0,0,1,.37-.15H287a.49.49,0,0,1,.5.45l1,10.74a.51.51,0,0,1-.5.55Zm-15.41-1h14.86l-.94-9.74H272.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.45 317.32 363.84 306.58 348.46 306.58 351.56 317.32 367.45 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.45,317.82H351.56a.5.5,0,0,1-.48-.36L348,306.71a.51.51,0,0,1,.48-.63h15.38a.5.5,0,0,1,.48.34l3.61,10.74a.52.52,0,0,1-.07.45A.51.51,0,0,1,367.45,317.82Zm-15.51-1h14.82l-3.28-9.74H349.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.78 317.32 317.71 306.58 302.33 306.58 303.88 317.32 319.78 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,317.82h-15.9a.5.5,0,0,1-.49-.43l-1.55-10.74a.49.49,0,0,1,.49-.57h15.38a.5.5,0,0,1,.49.4l2.07,10.74a.51.51,0,0,1-.49.6Zm-15.46-1h14.85l-1.87-9.74H302.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.88 317.32 302.33 306.58 286.95 306.58 287.99 317.32 303.88 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.88,317.82H288a.51.51,0,0,1-.5-.45l-1-10.75a.47.47,0,0,1,.12-.38.52.52,0,0,1,.37-.16h15.38a.51.51,0,0,1,.5.42l1.55,10.75a.49.49,0,0,1-.12.4A.52.52,0,0,1,303.88,317.82Zm-15.43-1h14.86l-1.41-9.74H287.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.21 317.32 256.2 306.58 240.82 306.58 240.31 317.32 256.21 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.21,317.82H240.32a.52.52,0,0,1-.37-.16.5.5,0,0,1-.13-.37l.5-10.74a.5.5,0,0,1,.5-.47H256.2a.5.5,0,0,1,.5.5v10.74a.51.51,0,0,1-.15.35A.47.47,0,0,1,256.21,317.82Zm-15.37-1h14.87v-9.74H241.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.96 317.32 129.07 317.32 124.68 328.8 141.12 328.8 144.96 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,329.3H124.68a.51.51,0,0,1-.41-.21.56.56,0,0,1-.06-.47l4.39-11.48a.51.51,0,0,1,.47-.32H145a.52.52,0,0,1,.41.21.51.51,0,0,1,.07.45L141.6,329A.5.5,0,0,1,141.12,329.3Zm-15.71-1h15.35l3.51-10.48H129.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.55 306.58 133.17 306.58 129.07 317.32 144.96 317.32 148.55 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,317.82H129.07a.49.49,0,0,1-.41-.22.48.48,0,0,1-.06-.46l4.11-10.74a.48.48,0,0,1,.46-.32h15.38a.49.49,0,0,1,.48.65l-3.59,10.75A.51.51,0,0,1,145,317.82Zm-15.16-1h14.8l3.26-9.74H133.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.85 317.32 163.93 306.58 148.55 306.58 144.96 317.32 160.85 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,317.82H145a.5.5,0,0,1-.47-.66l3.59-10.74a.49.49,0,0,1,.47-.34h15.38a.49.49,0,0,1,.4.2.5.5,0,0,1,.08.43l-3.08,10.75A.5.5,0,0,1,160.85,317.82Zm-15.19-1h14.82l2.79-9.74H148.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.98 341.11 114.93 354.34 132.59 354.34 137.01 341.11 119.98 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.59,354.84H114.93a.54.54,0,0,1-.42-.22.5.5,0,0,1-.05-.46l5.05-13.23a.51.51,0,0,1,.47-.32h17a.52.52,0,0,1,.41.21.48.48,0,0,1,.06.45l-4.41,13.22A.5.5,0,0,1,132.59,354.84Zm-16.94-1h16.58l4.09-12.23h-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 328.8 124.68 328.8 119.98 341.11 137.01 341.11 141.12 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,341.61H120a.5.5,0,0,1-.47-.68l4.7-12.31a.51.51,0,0,1,.47-.32h16.44a.52.52,0,0,1,.41.21.52.52,0,0,1,.07.45l-4.12,12.31A.5.5,0,0,1,137,341.61Zm-16.31-1h16l3.78-11.31H125Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.01 341.11 132.59 354.34 150.25 354.34 154.04 341.11 137.01 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,354.84H132.59a.5.5,0,0,1-.47-.66L136.54,341a.5.5,0,0,1,.47-.34h17a.51.51,0,0,1,.4.2.5.5,0,0,1,.08.44l-3.78,13.22A.51.51,0,0,1,150.26,354.84Zm-17-1h16.59l3.5-12.23h-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.53 317.32 210.06 306.58 194.69 306.58 192.64 317.32 208.53 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.53,317.82H192.64a.53.53,0,0,1-.39-.18.53.53,0,0,1-.1-.42l2-10.74a.51.51,0,0,1,.5-.4h15.37a.5.5,0,0,1,.5.57L209,317.39A.51.51,0,0,1,208.53,317.82Zm-15.29-1H208.1l1.39-9.74H195.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.89 328.8 208.53 317.32 192.64 317.32 190.45 328.8 206.89 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.89,329.3H190.45a.49.49,0,0,1-.49-.59l2.19-11.49a.49.49,0,0,1,.49-.4h15.89a.5.5,0,0,1,.38.17.53.53,0,0,1,.12.4l-1.64,11.48A.51.51,0,0,1,206.89,329.3Zm-15.84-1h15.41L208,317.82h-14.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.45 328.8 192.64 317.32 176.75 317.32 174.01 328.8 190.45 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.45,329.3H174a.51.51,0,0,1-.4-.19.52.52,0,0,1-.09-.42l2.74-11.49a.5.5,0,0,1,.49-.38h15.89a.46.46,0,0,1,.38.18.48.48,0,0,1,.11.41l-2.19,11.49A.49.49,0,0,1,190.45,329.3Zm-15.81-1H190l2-10.48H177.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.33 328.8 224.42 317.32 208.53 317.32 206.89 328.8 223.33 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33,329.3H206.89a.49.49,0,0,1-.49-.57L208,317.25a.49.49,0,0,1,.49-.43h15.89a.51.51,0,0,1,.37.16.52.52,0,0,1,.13.39l-1.09,11.48A.49.49,0,0,1,223.33,329.3Zm-15.86-1h15.41l1-10.48H209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.85 317.32 144.96 317.32 141.12 328.8 157.57 328.8 160.85 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.57,329.3H141.12a.48.48,0,0,1-.4-.2.49.49,0,0,1-.07-.45l3.84-11.49a.51.51,0,0,1,.47-.34h15.89a.48.48,0,0,1,.4.2.46.46,0,0,1,.08.44l-3.28,11.48A.5.5,0,0,1,157.57,329.3Zm-15.75-1h15.37l3-10.48H145.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.42 341.11 375.45 341.11 371.31 328.8 354.87 328.8 358.42 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.45,341.61h-17a.5.5,0,0,1-.48-.36l-3.55-12.31a.53.53,0,0,1,.08-.44.52.52,0,0,1,.4-.2h16.44a.51.51,0,0,1,.48.34L375.92,341a.48.48,0,0,1-.07.45A.46.46,0,0,1,375.45,341.61Zm-16.66-1h16L371,329.3H355.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 328.8 176.75 317.32 160.85 317.32 157.57 328.8 174.01 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,329.3H157.57a.48.48,0,0,1-.4-.2.45.45,0,0,1-.08-.43l3.28-11.49a.5.5,0,0,1,.48-.36h15.9a.51.51,0,0,1,.39.19.49.49,0,0,1,.09.42l-2.74,11.49A.49.49,0,0,1,174,329.3Zm-15.78-1h15.38l2.5-10.48H161.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.12 328.8 137.01 341.11 154.04 341.11 157.57 328.8 141.12 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,341.61H137a.49.49,0,0,1-.41-.21.48.48,0,0,1-.06-.45l4.11-12.3a.5.5,0,0,1,.47-.35h16.45a.51.51,0,0,1,.48.64l-3.53,12.31A.5.5,0,0,1,154,341.61Zm-16.34-1h16l3.24-11.31H141.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.99 328.8 319.78 317.32 303.88 317.32 305.54 328.8 321.99 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,329.3H305.54a.5.5,0,0,1-.49-.42l-1.66-11.49a.49.49,0,0,1,.12-.4.48.48,0,0,1,.37-.17h15.9a.5.5,0,0,1,.49.4l2.21,11.49a.5.5,0,0,1-.49.59Zm-16-1h15.4l-2-10.48h-14.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.54 328.8 303.88 317.32 287.99 317.32 289.1 328.8 305.54 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.54,329.3H289.1a.5.5,0,0,1-.5-.45l-1.11-11.48a.56.56,0,0,1,.13-.39.52.52,0,0,1,.37-.16h15.89a.51.51,0,0,1,.5.43L306,328.73a.5.5,0,0,1-.5.57Zm-16-1H305l-1.52-10.48H288.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "354.87 328.8 351.56 317.32 335.67 317.32 338.43 328.8 354.87 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.87,329.3H338.43a.5.5,0,0,1-.49-.38l-2.76-11.48a.51.51,0,0,1,.1-.43.49.49,0,0,1,.39-.19h15.89a.5.5,0,0,1,.48.36l3.31,11.49a.5.5,0,0,1-.08.43A.49.49,0,0,1,354.87,329.3Zm-16.05-1h15.39l-3-10.48H336.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.22 328.8 256.21 317.32 240.31 317.32 239.78 328.8 256.22 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.22,329.3H239.78a.51.51,0,0,1-.37-.15.5.5,0,0,1-.13-.37l.54-11.49a.5.5,0,0,1,.5-.47h15.89a.5.5,0,0,1,.5.5V328.8a.49.49,0,0,1-.15.36A.5.5,0,0,1,256.22,329.3Zm-15.92-1h15.42V317.82H240.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.1 328.8 287.99 317.32 272.1 317.32 272.66 328.8 289.1 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.1,329.3H272.66a.5.5,0,0,1-.5-.47l-.56-11.49a.48.48,0,0,1,.14-.37.48.48,0,0,1,.36-.15H288a.5.5,0,0,1,.5.45l1.11,11.49a.48.48,0,0,1-.13.38A.51.51,0,0,1,289.1,329.3Zm-16-1h15.41l-1-10.48H272.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 328.8 272.1 317.32 256.21 317.32 256.22 328.8 272.66 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.66,329.3H256.22a.5.5,0,0,1-.5-.5V317.32a.54.54,0,0,1,.14-.36.52.52,0,0,1,.36-.14H272.1a.5.5,0,0,1,.5.47l.56,11.49a.47.47,0,0,1-.14.37A.48.48,0,0,1,272.66,329.3Zm-15.94-1h15.42l-.52-10.48H256.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.78 328.8 240.31 317.32 224.42 317.32 223.33 328.8 239.78 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.78,329.3H223.33a.52.52,0,0,1-.37-.16.47.47,0,0,1-.12-.38l1.09-11.49a.49.49,0,0,1,.49-.45h15.9a.48.48,0,0,1,.49.52l-.53,11.49A.51.51,0,0,1,239.78,329.3Zm-15.9-1H239.3l.49-10.48H224.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.1 328.8 290.29 341.11 307.32 341.11 305.54 328.8 289.1 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.32,341.61h-17a.5.5,0,0,1-.5-.45l-1.19-12.31a.52.52,0,0,1,.13-.38.5.5,0,0,1,.37-.17h16.44a.51.51,0,0,1,.5.43L307.82,341a.49.49,0,0,1-.12.4A.49.49,0,0,1,307.32,341.61Zm-16.57-1h16l-1.64-11.31H289.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.54 328.8 307.32 341.11 324.36 341.11 321.99 328.8 305.54 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.35,341.61h-17a.49.49,0,0,1-.49-.43l-1.78-12.3a.48.48,0,0,1,.12-.4.49.49,0,0,1,.37-.18H322a.5.5,0,0,1,.49.41L324.85,341a.51.51,0,0,1-.11.41A.5.5,0,0,1,324.35,341.61Zm-16.59-1h16l-2.18-11.31H306.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.57 328.8 154.04 341.11 171.07 341.11 174.01 328.8 157.57 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.07,341.61H154a.49.49,0,0,1-.4-.2.52.52,0,0,1-.08-.44l3.53-12.3a.49.49,0,0,1,.48-.37H174a.5.5,0,0,1,.48.62l-2.93,12.31A.5.5,0,0,1,171.07,341.61Zm-16.37-1h16l2.69-11.31H157.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.99 328.8 324.36 341.11 341.39 341.11 338.43 328.8 321.99 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.39,341.61h-17a.51.51,0,0,1-.49-.4L321.5,328.9a.49.49,0,0,1,.1-.41.51.51,0,0,1,.39-.19h16.44a.49.49,0,0,1,.48.39l3,12.31a.49.49,0,0,1-.09.42A.51.51,0,0,1,341.39,341.61Zm-16.62-1h16L338,329.3H322.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.22 328.8 256.23 341.11 273.26 341.11 272.66 328.8 256.22 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.26,341.61h-17a.5.5,0,0,1-.5-.5V328.8a.5.5,0,0,1,.14-.35.55.55,0,0,1,.36-.15h16.44a.5.5,0,0,1,.5.48l.6,12.31a.48.48,0,0,1-.14.37A.48.48,0,0,1,273.26,341.61Zm-16.53-1h16l-.56-11.31H256.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.43 328.8 341.39 341.11 358.42 341.11 354.87 328.8 338.43 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.42,341.61h-17a.5.5,0,0,1-.49-.38l-3-12.31a.51.51,0,0,1,.1-.43.48.48,0,0,1,.39-.19h16.44a.5.5,0,0,1,.48.37L358.9,341a.53.53,0,0,1-.08.44A.51.51,0,0,1,358.42,341.61Zm-16.64-1h16l-3.26-11.31H339.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.66 328.8 273.26 341.11 290.29 341.11 289.1 328.8 272.66 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.29,341.61h-17a.5.5,0,0,1-.5-.47l-.6-12.31a.47.47,0,0,1,.14-.37.48.48,0,0,1,.36-.16H289.1a.5.5,0,0,1,.5.46l1.19,12.3a.52.52,0,0,1-.13.39A.51.51,0,0,1,290.29,341.61Zm-16.55-1h16l-1.09-11.31H273.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.45 328.8 188.1 341.11 205.13 341.11 206.89 328.8 190.45 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.14,341.61h-17a.48.48,0,0,1-.38-.18.5.5,0,0,1-.11-.41L190,328.71a.49.49,0,0,1,.49-.41h16.44a.51.51,0,0,1,.5.57l-1.76,12.31A.5.5,0,0,1,205.14,341.61Zm-16.43-1h16l1.62-11.31H190.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.01 328.8 171.07 341.11 188.1 341.11 190.45 328.8 174.01 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,341.61h-17a.51.51,0,0,1-.39-.19.49.49,0,0,1-.09-.42l2.93-12.31a.5.5,0,0,1,.49-.39h16.44a.47.47,0,0,1,.38.19.47.47,0,0,1,.11.41l-2.34,12.31A.51.51,0,0,1,188.1,341.61Zm-16.39-1h16l2.15-11.31H174.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.78 328.8 239.2 341.11 256.23 341.11 256.22 328.8 239.78 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.23,341.61h-17a.48.48,0,0,1-.36-.15.47.47,0,0,1-.14-.37l.58-12.31a.5.5,0,0,1,.5-.48h16.44a.51.51,0,0,1,.5.5v12.31a.51.51,0,0,1-.15.36A.5.5,0,0,1,256.23,341.61Zm-16.51-1h16V329.3H240.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.33 328.8 222.17 341.11 239.2 341.11 239.78 328.8 223.33 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2,341.61h-17a.51.51,0,0,1-.37-.16.49.49,0,0,1-.13-.38l1.17-12.31a.5.5,0,0,1,.49-.46h16.45a.52.52,0,0,1,.36.16.55.55,0,0,1,.14.37l-.58,12.31A.51.51,0,0,1,239.2,341.61Zm-16.48-1h16l.53-11.31H223.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.89 328.8 205.13 341.11 222.17 341.11 223.33 328.8 206.89 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.17,341.61h-17a.5.5,0,0,1-.5-.57l1.76-12.31a.5.5,0,0,1,.49-.43h16.44a.48.48,0,0,1,.37.17.45.45,0,0,1,.13.38l-1.17,12.31A.49.49,0,0,1,222.17,341.61Zm-16.46-1h16l1.07-11.31H207.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.43 328.8 335.67 317.32 319.78 317.32 321.99 328.8 338.43 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.43,329.3H322a.49.49,0,0,1-.49-.4l-2.21-11.49a.51.51,0,0,1,.1-.41.5.5,0,0,1,.39-.18h15.89a.51.51,0,0,1,.49.38l2.75,11.49a.46.46,0,0,1-.09.42A.49.49,0,0,1,338.43,329.3Zm-16-1h15.39l-2.52-10.48H320.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.55 306.58 152.23 295.58 137.38 295.58 133.17 306.58 148.55 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.55,307.08H133.17a.5.5,0,0,1-.46-.68l4.2-11a.5.5,0,0,1,.46-.32h14.86a.5.5,0,0,1,.47.66l-3.67,11A.5.5,0,0,1,148.55,307.08Zm-14.65-1h14.29l3.34-10H137.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.17 306.58 118.98 306.58 114.4 317.32 129.07 317.32 133.17 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07,317.82H114.4a.52.52,0,0,1-.42-.23.49.49,0,0,1,0-.47l4.58-10.74a.51.51,0,0,1,.46-.3h14.19a.53.53,0,0,1,.42.21.5.5,0,0,1,0,.46l-4.1,10.75A.51.51,0,0,1,129.07,317.82Zm-13.91-1h13.57l3.72-9.74H119.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.38 295.58 123.67 295.58 118.98 306.58 133.17 306.58 137.38 295.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17,307.08H119a.5.5,0,0,1-.42-.23.49.49,0,0,1,0-.47l4.69-11a.48.48,0,0,1,.46-.3h13.7a.51.51,0,0,1,.42.22.5.5,0,0,1,.05.46l-4.2,11A.5.5,0,0,1,133.17,307.08Zm-13.43-1h13.09l3.82-10H124Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.07 317.32 114.4 317.32 109.5 328.8 124.68 328.8 129.07 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.68,329.3H109.5a.5.5,0,0,1-.46-.69l4.9-11.49a.51.51,0,0,1,.46-.3h14.67a.49.49,0,0,1,.41.22.47.47,0,0,1,.06.46L125.15,329A.5.5,0,0,1,124.68,329.3Zm-14.42-1h14.08l4-10.48H114.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.68 328.8 109.5 328.8 104.26 341.11 119.98 341.11 124.68 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,341.61H104.26a.49.49,0,0,1-.46-.69L109,328.61a.5.5,0,0,1,.46-.31h15.18a.51.51,0,0,1,.47.68l-4.7,12.31A.51.51,0,0,1,120,341.61Zm-15-1h14.62L124,329.3H109.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.98 341.11 104.26 341.11 98.62 354.34 114.93 354.34 119.98 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.93,354.84H98.62a.52.52,0,0,1-.42-.23.49.49,0,0,1,0-.47l5.64-13.22a.5.5,0,0,1,.46-.31H120a.49.49,0,0,1,.41.22.53.53,0,0,1,.06.46l-5.06,13.22A.49.49,0,0,1,114.93,354.84Zm-15.55-1h15.2l4.67-12.23H104.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 317.32 387.75 328.8 402.3 328.8 397.4 317.32 383.35 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.3,329.3H387.76a.49.49,0,0,1-.47-.32l-4.41-11.48a.5.5,0,0,1,.05-.46.5.5,0,0,1,.41-.22H397.4a.49.49,0,0,1,.46.3l4.9,11.49a.49.49,0,0,1,0,.47A.51.51,0,0,1,402.3,329.3Zm-14.2-1h13.44l-4.47-10.48h-13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.48 341.11 407.55 341.11 402.3 328.8 387.75 328.8 392.48 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.55,341.61H392.48a.51.51,0,0,1-.47-.32L387.29,329a.5.5,0,0,1,.47-.68H402.3a.5.5,0,0,1,.46.31L408,340.92a.5.5,0,0,1-.46.69Zm-14.73-1h14L402,329.3H388.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.56 354.34 413.18 354.34 407.55 341.11 392.48 341.11 397.56 354.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.18,354.84H397.56a.5.5,0,0,1-.47-.32L392,341.29a.51.51,0,0,1,.47-.68h15.07a.5.5,0,0,1,.46.31l5.63,13.22a.49.49,0,0,1,0,.47A.5.5,0,0,1,413.18,354.84Zm-15.28-1h14.53l-5.21-12.23h-14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.57 306.58 271.04 295.58 256.19 295.58 256.2 306.58 271.57 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.58,307.08H256.2a.5.5,0,0,1-.5-.5v-11a.5.5,0,0,1,.14-.35.49.49,0,0,1,.36-.15H271a.5.5,0,0,1,.5.48l.53,11a.5.5,0,0,1-.13.37A.52.52,0,0,1,271.58,307.08Zm-14.88-1h14.35l-.49-10H256.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 317.32 397.4 317.32 392.82 306.58 379.22 306.58 383.35 317.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.4,317.82H383.34a.5.5,0,0,1-.46-.32l-4.12-10.75a.49.49,0,0,1,.46-.67h13.61a.51.51,0,0,1,.46.3l4.57,10.74a.49.49,0,0,1,0,.47A.5.5,0,0,1,397.4,317.82Zm-13.71-1h13l-4.15-9.74H380Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.45 341.11 392.48 341.11 387.75 328.8 371.31 328.8 375.45 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.48,341.61h-17a.5.5,0,0,1-.48-.34L370.84,329a.5.5,0,0,1,.47-.66h16.45a.5.5,0,0,1,.46.32L393,340.93a.52.52,0,0,1-.06.47A.51.51,0,0,1,392.48,341.61Zm-16.67-1h15.94l-4.34-11.31H372Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.93 306.58 167.08 295.58 152.23 295.58 148.55 306.58 163.93 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.93,307.08H148.55a.5.5,0,0,1-.47-.66l3.67-11a.51.51,0,0,1,.48-.34h14.85a.51.51,0,0,1,.4.2.53.53,0,0,1,.08.44l-3.15,11A.5.5,0,0,1,163.93,307.08Zm-14.68-1h14.3l2.86-10H152.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 306.58 367.45 317.32 383.35 317.32 379.22 306.58 363.84 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,317.82H367.45a.51.51,0,0,1-.47-.34l-3.61-10.74a.51.51,0,0,1,.07-.46.48.48,0,0,1,.4-.2h15.38a.5.5,0,0,1,.47.32l4.12,10.74a.5.5,0,0,1-.05.46A.51.51,0,0,1,383.34,317.82Zm-15.53-1h14.81l-3.74-9.74H364.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.82 306.58 388.14 295.58 375 295.58 379.22 306.58 392.82 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.83,307.08H379.22a.49.49,0,0,1-.46-.32l-4.23-11a.5.5,0,0,1,.06-.46.49.49,0,0,1,.41-.22h13.14a.51.51,0,0,1,.46.3l4.69,11a.49.49,0,0,1-.05.47A.5.5,0,0,1,392.83,307.08Zm-13.26-1h12.5l-4.26-10H375.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.22 306.58 375 295.58 360.15 295.58 363.84 306.58 379.22 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.22,307.08H363.84a.51.51,0,0,1-.47-.34l-3.7-11a.52.52,0,0,1,.07-.45.52.52,0,0,1,.41-.21H375a.51.51,0,0,1,.47.32l4.22,11a.51.51,0,0,1-.47.68Zm-15-1h14.29l-3.83-10H360.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.36 341.11 326.9 354.34 344.56 354.34 341.39 341.11 324.36 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.56,354.84H326.9a.49.49,0,0,1-.49-.41l-2.55-13.22a.53.53,0,0,1,.11-.42.51.51,0,0,1,.38-.18h17a.49.49,0,0,1,.48.39l3.18,13.22a.51.51,0,0,1-.09.43A.51.51,0,0,1,344.56,354.84Zm-17.25-1h16.62L341,341.61H325Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.89 354.34 397.56 354.34 392.48 341.11 375.45 341.11 379.89 354.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.56,354.84H379.89a.51.51,0,0,1-.47-.34L375,341.27a.52.52,0,0,1,.07-.45.52.52,0,0,1,.41-.21h17a.51.51,0,0,1,.47.32L398,354.16a.5.5,0,0,1,0,.46A.52.52,0,0,1,397.56,354.84Zm-17.31-1h16.58l-4.69-12.23h-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.84 306.58 360.15 295.58 345.3 295.58 348.46 306.58 363.84 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.84,307.08H348.46a.51.51,0,0,1-.48-.37l-3.16-11a.47.47,0,0,1,.08-.44.51.51,0,0,1,.4-.2h14.85a.51.51,0,0,1,.47.34l3.7,11a.52.52,0,0,1-.07.45A.51.51,0,0,1,363.84,307.08Zm-15-1h14.31l-3.36-10H346Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.42 341.11 362.23 354.34 379.89 354.34 375.45 341.11 358.42 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.89,354.84H362.23a.5.5,0,0,1-.48-.37l-3.81-13.22a.47.47,0,0,1,.08-.44.51.51,0,0,1,.4-.2h17a.51.51,0,0,1,.47.34l4.45,13.23a.52.52,0,0,1-.07.45A.52.52,0,0,1,379.89,354.84Zm-17.29-1h16.6l-4.11-12.23h-16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.39 341.11 344.56 354.34 362.23 354.34 358.42 341.11 341.39 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.23,354.84H344.56a.49.49,0,0,1-.48-.39l-3.18-13.22a.51.51,0,0,1,.09-.43.51.51,0,0,1,.4-.19h17a.5.5,0,0,1,.48.36l3.81,13.23a.53.53,0,0,1-.08.44A.54.54,0,0,1,362.23,354.84Zm-17.27-1h16.6L358,341.61H342Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.31 328.8 387.75 328.8 383.35 317.32 367.45 317.32 371.31 328.8",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.76,329.3H371.31a.49.49,0,0,1-.47-.34L367,317.48a.5.5,0,0,1,.47-.66h15.89a.5.5,0,0,1,.47.32l4.41,11.48a.49.49,0,0,1-.46.68Zm-16.09-1H387l-4-10.48H368.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.44 306.58 226.48 295.58 211.63 295.58 210.06 306.58 225.44 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,307.08H210.06a.49.49,0,0,1-.37-.18.47.47,0,0,1-.12-.39l1.57-11a.49.49,0,0,1,.49-.43h14.85a.51.51,0,0,1,.37.16.48.48,0,0,1,.13.39l-1,11A.5.5,0,0,1,225.44,307.08Zm-14.8-1H225l.94-10H212.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.46 306.58 345.3 295.58 330.45 295.58 333.09 306.58 348.46 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.46,307.08H333.09a.5.5,0,0,1-.49-.39l-2.64-11a.51.51,0,0,1,.09-.43.51.51,0,0,1,.4-.19H345.3a.5.5,0,0,1,.48.36l3.17,11a.51.51,0,0,1-.49.64Zm-15-1H347.8l-2.88-10H331.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.06 306.58 211.63 295.58 196.78 295.58 194.69 306.58 210.06 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.06,307.08H194.69a.51.51,0,0,1-.39-.19.54.54,0,0,1-.11-.41l2.1-11a.49.49,0,0,1,.49-.41h14.85a.49.49,0,0,1,.38.17.49.49,0,0,1,.12.4l-1.57,11A.51.51,0,0,1,210.06,307.08Zm-14.77-1h14.34l1.43-10H197.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.2 306.58 256.19 295.58 241.34 295.58 240.82 306.58 256.2 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,307.08H240.82a.48.48,0,0,1-.36-.16.47.47,0,0,1-.14-.37l.52-11a.5.5,0,0,1,.5-.48h14.85a.5.5,0,0,1,.5.5v11a.51.51,0,0,1-.5.5Zm-14.86-1H255.7v-10H241.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.69 306.58 196.78 295.58 181.93 295.58 179.31 306.58 194.69 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.69,307.08H179.31a.51.51,0,0,1-.4-.19.54.54,0,0,1-.09-.43l2.62-11a.51.51,0,0,1,.49-.38h14.85a.53.53,0,0,1,.39.18.51.51,0,0,1,.1.41l-2.09,11A.5.5,0,0,1,194.69,307.08Zm-14.75-1h14.33l1.91-10H182.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.31 306.58 181.93 295.58 167.08 295.58 163.93 306.58 179.31 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.31,307.08H163.93a.51.51,0,0,1-.4-.2.53.53,0,0,1-.08-.44l3.15-11a.5.5,0,0,1,.48-.36h14.85a.49.49,0,0,1,.39.19.51.51,0,0,1,.1.43l-2.63,11A.49.49,0,0,1,179.31,307.08Zm-14.72-1h14.32l2.39-10H167.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.82 306.58 241.34 295.58 226.48 295.58 225.44 306.58 240.82 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.82,307.08H225.44a.5.5,0,0,1-.37-.17.52.52,0,0,1-.13-.38l1.05-11a.5.5,0,0,1,.49-.45h14.86a.52.52,0,0,1,.36.16.52.52,0,0,1,.14.36l-.52,11A.5.5,0,0,1,240.82,307.08Zm-14.83-1h14.35l.47-10H226.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.09 306.58 330.45 295.58 315.59 295.58 317.71 306.58 333.09 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.09,307.08H317.71a.49.49,0,0,1-.49-.41l-2.12-11a.51.51,0,0,1,.49-.6h14.86a.49.49,0,0,1,.48.38l2.64,11a.5.5,0,0,1-.48.62Zm-15-1h14.33l-2.4-10H316.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.71 306.58 315.59 295.58 300.74 295.58 302.33 306.58 317.71 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.71,307.08H302.33a.5.5,0,0,1-.49-.43l-1.59-11a.52.52,0,0,1,.11-.4.52.52,0,0,1,.38-.17h14.85a.51.51,0,0,1,.5.41l2.11,11a.47.47,0,0,1-.11.41A.47.47,0,0,1,317.71,307.08Zm-14.95-1H317.1l-1.92-10H301.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.95 306.58 285.89 295.58 271.04 295.58 271.57 306.58 286.95 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,307.08H271.58a.5.5,0,0,1-.5-.48l-.54-11a.46.46,0,0,1,.14-.37.48.48,0,0,1,.36-.16h14.85a.51.51,0,0,1,.5.45l1.06,11a.51.51,0,0,1-.5.55Zm-14.9-1H286.4l-1-10H271.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.36 341.11 307.32 341.11 290.29 341.11 273.26 341.11 256.23 341.11 239.2 341.11 222.17 341.11 205.13 341.11 188.1 341.11 171.07 341.11 154.04 341.11 150.25 354.34 167.92 354.34 185.58 354.34 203.25 354.34 220.91 354.34 238.58 354.34 256.24 354.34 273.91 354.34 291.57 354.34 309.23 354.34 326.9 354.34 324.36 341.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,354.84H150.26a.51.51,0,0,1-.4-.2.47.47,0,0,1-.08-.44L153.56,341a.5.5,0,0,1,.48-.36H324.35a.51.51,0,0,1,.5.41l2.54,13.22a.49.49,0,0,1-.1.41A.51.51,0,0,1,326.9,354.84Zm-176-1H326.29l-2.35-12.23H154.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.33 306.58 300.74 295.58 285.89 295.58 286.95 306.58 302.33 306.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.33,307.08H287a.5.5,0,0,1-.49-.46l-1.07-11a.52.52,0,0,1,.13-.38.48.48,0,0,1,.37-.17h14.85a.51.51,0,0,1,.5.43l1.59,11a.52.52,0,0,1-.12.4A.51.51,0,0,1,302.33,307.08Zm-14.92-1h14.34l-1.44-10H286.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.28,
    y: 377.57,
    width: 378.52,
    height: 5.37,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.8,383.44H63.28a.5.5,0,0,1-.5-.5v-5.37a.5.5,0,0,1,.5-.5H441.8a.5.5,0,0,1,.5.5v5.37A.5.5,0,0,1,441.8,383.44Zm-378-1H441.3v-4.37H63.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,120.52h-16.5a1.5,1.5,0,0,1,0-3h16.5a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,129h-62a1.5,1.5,0,1,1,0-3h62a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,129H236.88a1.5,1.5,0,1,1,0-3h61.95a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,129H207a1.5,1.5,0,1,1,0-3h24.51a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,137.46H141.05a1.5,1.5,0,0,1,0-3h35.66a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,137.46H181.17a1.5,1.5,0,0,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,137.46H221.28a1.5,1.5,0,0,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,137.46H261.39a1.5,1.5,0,0,1,0-3h15.15a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,120.52H162a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,120.52H260.05a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,120.52H238.21a1.5,1.5,0,0,1,0-3H254.7a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,120.52H183a1.5,1.5,0,0,1,0-3h48.13a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,172.22h-16.5a1.5,1.5,0,0,1,0-3h16.5a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,180.69h-62a1.5,1.5,0,0,1,0-3h62a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,180.69H236.88a1.5,1.5,0,0,1,0-3h61.95a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,180.69H207a1.5,1.5,0,0,1,0-3h24.51a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,189.16H141.05a1.5,1.5,0,0,1,0-3h35.66a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,189.16H181.17a1.5,1.5,0,0,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,189.16H221.28a1.5,1.5,0,0,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,189.16H261.39a1.5,1.5,0,0,1,0-3h15.15a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,172.22H162a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,172.22H260.05a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,172.22H238.21a1.5,1.5,0,0,1,0-3H254.7a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,172.22H183a1.5,1.5,0,0,1,0-3h48.13a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.55,248.43h-16.5a1.5,1.5,0,0,1,0-3h16.5a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,256.9h-62a1.5,1.5,0,0,1,0-3h62a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.83,256.9H236.88a1.5,1.5,0,0,1,0-3h61.95a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,256.9H207a1.5,1.5,0,0,1,0-3h24.51a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.71,265.37H141.05a1.5,1.5,0,0,1,0-3h35.66a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.82,265.37H181.17a1.5,1.5,0,1,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.93,265.37H221.28a1.5,1.5,0,1,1,0-3h35.65a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,265.37H261.39a1.5,1.5,0,0,1,0-3h15.15a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.49,248.43H162a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,248.43H260.05a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7,248.43H238.21a1.5,1.5,0,1,1,0-3H254.7a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.08,248.43H183a1.5,1.5,0,0,1,0-3h48.13a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,146.37H233.76a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,146.37H211.92a1.5,1.5,0,1,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,146.37H156.65a1.5,1.5,0,1,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,161.52H233.76a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,161.52H211.92a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,161.52H156.65a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,154H156.65a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,154H178.49a1.5,1.5,0,0,1,0-3H195a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,154H202.11a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,199.41H233.76a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,199.41H211.92a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,199.41H156.65a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,214.56H233.76a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,214.56H211.92a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,214.56H156.65a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,207H156.65a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,207H178.49a1.5,1.5,0,0,1,0-3H195a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,207H202.11a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,223.48H156.65a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,223.48H178.49a1.5,1.5,0,0,1,0-3H195a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,223.48H202.11a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.14,238.63H156.65a1.5,1.5,0,1,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,238.63H178.49a1.5,1.5,0,0,1,0-3H195a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,238.63H202.11a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,231.05H233.76a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,0,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.41,231.05H211.92a1.5,1.5,0,0,1,0-3h16.49a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.79,231.05H156.65a1.5,1.5,0,0,1,0-3h48.14a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 116.08,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 124.62,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 133.17,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 141.71,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 150.25,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 158.8,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 167.34,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 175.88,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 184.43,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 192.97,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 201.51,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 210.06,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 218.6,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 227.14,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 235.69,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 244.23,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 252.77,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.67,
    y: 261.32,
    width: 5.27,
    height: 5.2,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380,22.66a57.18,57.18,0,0,0-39.52,98.51l-8.14,15.2,20-6.48A57.19,57.19,0,1,0,380,22.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,137.55a57.64,57.64,0,0,1-27.75-7.12l-19.76,6.41a.53.53,0,0,1-.54-.15.5.5,0,0,1-.05-.56l8-14.86a57.69,57.69,0,1,1,97.83-41.42A57.76,57.76,0,0,1,380,137.55Zm-27.7-8.16a.42.42,0,0,1,.24.07,56.7,56.7,0,1,0-29.23-49.61,56.22,56.22,0,0,0,17.51,41,.52.52,0,0,1,.1.6l-7.55,14.1,18.77-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.31,18.58a57.18,57.18,0,0,0-39.52,98.51l-8.14,15.19,20-6.47A57.19,57.19,0,1,0,377.31,18.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.31,133.46a57.8,57.8,0,0,1-27.75-7.11l-19.75,6.41a.51.51,0,0,1-.54-.16.52.52,0,0,1-.06-.56l8-14.85a57.69,57.69,0,1,1,40.14,16.27Zm-27.69-8.15a.53.53,0,0,1,.24.06,56.82,56.82,0,1,0-11.72-8.64.49.49,0,0,1,.09.59l-7.55,14.1,18.78-6.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.16,99.34l-22-15.52V75.59l22-15.67v8.3L342.41,79.67l15.75,11.45Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.85,102.11,381.6,39.86h7.15l-16.83,62.25Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.43,99.34V91.12l15.83-11.53L395.43,68.22v-8.3l22.06,15.6v8.22Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.89,95.93l-22-15.52V72.19l22-15.68v8.3L345.13,76.26l15.76,11.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.57,98.7l16.75-62.24h7.15L374.64,98.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.15,95.93V87.71L414,76.19,398.15,64.81v-8.3l22.06,15.6v8.23Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-2--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.83,383.53l34.63,28.59a49.6,49.6,0,0,0,6.81,11.57c4.77,6.13,60.6,29.28,60.6,29.28l9.53,2.72-104.17-78.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.4,456.19a.36.36,0,0,1-.14,0l-9.53-2.72c-2.34-1-56.06-23.29-60.85-29.45a49.76,49.76,0,0,1-6.83-11.58l-34.53-28.5a.51.51,0,0,1-.19-.39.53.53,0,0,1,.18-.39l7.4-6.13a.5.5,0,0,1,.62,0l104.17,78.3a.51.51,0,0,1,.15.63A.5.5,0,0,1,445.4,456.19ZM334.62,383.53l34.16,28.2a.51.51,0,0,1,.15.21,49.13,49.13,0,0,0,6.74,11.45c4.63,5.95,59.83,28.89,60.39,29.12l6.88,2L341.24,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.28,360.82s-9.29-11.36-13.42-18.58-10-24.09-14.46-34.07-11-13.07-18.92-16.17-11-2.41-11-.34,3.1,5.85,3.1,5.85l-13.42,2.41s-5.51-3.1-8.95-2.07-10,7.57-10,7.57-6.88-2.41-11-1.38-15.48,6.54-20.3,8.95-10,2.75-9.64,4.82,5.17,5.5,9.64,4.82,12-3.45,16.86-3.45,7.22,1,9.63,2.76,12.39,15.83,13.77,17.55,2.75,8.6,2.75,8.6-6.07-2.59-9.85-6-9.2-11.51-15.4-12.19-12.94,4.81-9.5,7.56,6.88,4.47,9.29,7.57,6.19,12.39,12.73,22.37,20.64,16.17,20.64,16.17l29.25,12s7.57-17.89,21.68-22.71S403,366,403,366Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.08,396.07a.63.63,0,0,1-.19,0L333.64,384c-.15-.07-14.33-6.37-20.87-16.36a166.51,166.51,0,0,1-8.72-15.32,57,57,0,0,0-4-7,25.44,25.44,0,0,0-5.82-5c-1.1-.77-2.24-1.57-3.39-2.49a2.72,2.72,0,0,1-.85-3.39c1.14-2.76,6.08-5.58,10.73-5.06s9.07,5.23,12.49,9c1.15,1.26,2.23,2.45,3.18,3.31a38.9,38.9,0,0,0,8.83,5.54c-.51-2.29-1.54-6.28-2.45-7.42-.34-.42-1.16-1.53-2.28-3.07-3.37-4.59-9.62-13.13-11.39-14.39-2.36-1.68-4.64-2.66-9.34-2.66-2.92,0-7,1.07-10.58,2-2.3.6-4.47,1.16-6.21,1.43-4.59.7-9.79-2.79-10.2-5.23-.28-1.7,1.78-2.37,4.63-3.31a36.78,36.78,0,0,0,5.27-2c2.6-1.29,15.77-7.82,20.41-9,3.78-.95,9.61.83,11,1.29,1.19-1.17,6.77-6.52,10-7.48s8.21,1.51,9.17,2l12.43-2.23c-.92-1.23-2.69-3.79-2.69-5.5a2,2,0,0,1,.88-1.71c1.61-1.1,5.35-.55,10.81,1.59,8.13,3.18,14.71,6.41,19.2,16.43,1.76,3.92,3.68,8.77,5.71,13.91,3.06,7.74,6.23,15.74,8.72,20.11,4.06,7.11,13.28,18.4,13.37,18.51a.51.51,0,0,1,.09.16l1.72,5.16a.5.5,0,0,1-.25.61c-.17.08-4.32,2.13-18.3,6.91-13.73,4.68-21.3,22.25-21.38,22.43A.49.49,0,0,1,363.08,396.07ZM299.6,330.3c-3.85,0-7.77,2.3-8.68,4.5a1.75,1.75,0,0,0,.56,2.23c1.12.9,2.25,1.69,3.34,2.45a26.51,26.51,0,0,1,6,5.2,56.73,56.73,0,0,1,4.08,7.17,168.34,168.34,0,0,0,8.68,15.23c6.38,9.74,20.29,15.93,20.43,16l28.78,11.86c1.31-2.84,8.89-18.14,21.78-22.54,11.58-4,16.46-6.07,17.78-6.67l-1.55-4.66c-.8-1-9.48-11.69-13.41-18.57-2.53-4.43-5.71-12.47-8.78-20.24-2-5.13-3.95-10-5.69-13.87-4.35-9.7-10.47-12.71-18.65-15.91-7.09-2.78-9.28-2.11-9.89-1.69a1,1,0,0,0-.44.88c0,1.54,2.15,4.51,3,5.53a.5.5,0,0,1-.3.81l-13.42,2.41a.48.48,0,0,1-.33-.06s-5.36-3-8.56-2-9.7,7.38-9.77,7.44a.46.46,0,0,1-.51.12c-.07,0-6.79-2.34-10.73-1.36-3.52.88-13.08,5.35-20.2,8.91a37.68,37.68,0,0,1-5.41,2.09c-2.2.72-4.1,1.34-4,2.2.29,1.76,4.87,5,9.06,4.4,1.68-.26,3.83-.82,6.1-1.41,3.66-1,7.8-2,10.84-2,5,0,7.46,1.09,9.92,2.85,1.75,1.25,6.91,8.19,11.61,14.61,1.08,1.47,1.93,2.63,2.26,3,1.43,1.8,2.79,8.53,2.85,8.82a.51.51,0,0,1-.17.49.54.54,0,0,1-.52.07,42,42,0,0,1-10-6.13c-1-.89-2.08-2.1-3.25-3.38-3.31-3.65-7.44-8.2-11.86-8.69C300.28,330.32,299.94,330.3,299.6,330.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.27,318.31a.5.5,0,0,1-.12-1s3.35-.85,4.29-1.16a7.34,7.34,0,0,0,1.92-1.2.51.51,0,0,1,.71.06.49.49,0,0,1-.06.7,8.09,8.09,0,0,1-2.26,1.39c-1,.32-4.22,1.15-4.35,1.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.88,333a.46.46,0,0,1-.33-.13,19.43,19.43,0,0,1-4.95-8.45c-1.19-4-4.91-6-6.9-7l-.39-.21c-4.43-2.38-20.18-11.18-20.33-11.27a.51.51,0,0,1-.2-.68.5.5,0,0,1,.68-.2c.16.09,15.9,8.9,20.32,11.27l.39.21c2,1,6.08,3.21,7.39,7.63a18.8,18.8,0,0,0,4.66,8,.5.5,0,0,1-.34.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.64,323.13a.52.52,0,0,1-.45-.28s-1.73-3.47-3.43-6.52c-1.33-2.39-4-3-5.5-3.36-.32-.07-.58-.13-.76-.19-1.06-.36-14.06-10.45-16.66-12.47a.5.5,0,1,1,.61-.79c5.89,4.58,15.54,12,16.38,12.31.15.05.38.1.66.17,1.49.34,4.6,1.06,6.15,3.84,1.7,3.08,3.43,6.53,3.45,6.56a.5.5,0,0,1-.23.67A.43.43,0,0,1,359.64,323.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.15,315.21a.48.48,0,0,1-.38-.17c-.36-.41-9-10.07-11.08-14.21-1.87-3.74-7-2.84-7-2.83a.51.51,0,0,1-.59-.4.5.5,0,0,1,.4-.58c.06,0,5.91-1.06,8.11,3.36,2,4,10.85,13.9,10.94,14a.5.5,0,0,1,0,.7A.5.5,0,0,1,365.15,315.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,342.39a.51.51,0,0,1-.45-.27.5.5,0,0,1,.23-.67,4.9,4.9,0,0,0,2.29-2.46,2.39,2.39,0,0,0-.42-2c-1.89-2.83-5.74-2.87-5.78-2.87a.5.5,0,0,1,0-1c.18,0,4.42,0,6.61,3.32a3.31,3.31,0,0,1,.56,2.79,5.77,5.77,0,0,1-2.82,3.09A.42.42,0,0,1,297.36,342.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,356.35s-18.58,4.81-30.28,17.89-11.7,24.09-10.67,25.81S383,413.81,383,413.81s13.76-26.5,23.4-33S423,372.52,423,372.52s-17.2-11-17.89-12.39S403,355.31,400.59,356.35Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,414.31a.53.53,0,0,1-.24-.06c-3.75-2-22.54-12.2-23.59-13.95s-1.2-13.07,10.72-26.39c11.42-12.76,29.55-17.78,30.49-18,2.61-1.08,4.16,2.1,4.9,3.64l.19.4c.6,1,11.18,8,17.71,12.19a.5.5,0,0,1,.23.5.49.49,0,0,1-.38.4c-.06,0-6.92,1.79-16.35,8.19s-23.1,32.59-23.24,32.85a.51.51,0,0,1-.29.25Zm18.4-57.65a1.65,1.65,0,0,0-.66.15l-.07,0c-.18.05-18.57,4.94-30,17.74s-11.59,23.59-10.61,25.22c.72,1.17,14.15,8.69,22.76,13.34,1.92-3.63,14.27-26.62,23.33-32.77a63.61,63.61,0,0,1,15.6-8c-4.23-2.72-16.49-10.68-17.15-12l-.2-.41C403.64,358.33,402.71,356.66,401.44,356.66Zm-.85-.31h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,459.92s-18.93-9.64-23.4-12.05L394.39,429a41.74,41.74,0,0,1-5.85-2.06c-2.06-1-5.16-.69-6.53-7.92s2.06-21.68,17.55-36.13,25.11-13.76,25.11-13.76,6.54-.69,8.26.69,2.07,5.5,3.79,6.19,49.33,15,49.33,15",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.89,460.42a.49.49,0,0,1-.23-.06c-.19-.09-19-9.66-23.41-12l-35-18.9a40.44,40.44,0,0,1-5.89-2.09,10.7,10.7,0,0,0-1.11-.44c-2-.71-4.51-1.58-5.69-7.83s1.16-21.15,17.69-36.58c15.48-14.44,25.11-13.92,25.5-13.9.6-.07,6.71-.67,8.53.8a8.1,8.1,0,0,1,2,3.35c.48,1.22,1,2.48,1.69,2.77,1.68.67,48.82,14.8,49.29,14.94a.5.5,0,0,1-.28,1c-2-.59-47.66-14.29-49.38-15-1.1-.44-1.66-1.84-2.25-3.32a7.57,7.57,0,0,0-1.66-2.94c-1.28-1-6.13-.77-7.89-.58-.19,0-9.74-.46-24.83,13.63-16.22,15.13-18.57,29.54-17.4,35.67,1.08,5.67,3.18,6.41,5,7.07a9.55,9.55,0,0,1,1.23.49,40.52,40.52,0,0,0,5.76,2l.1,0,35.1,18.92c4.41,2.38,23.2,11.95,23.39,12a.51.51,0,0,1,.22.67A.5.5,0,0,1,452.89,460.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.62,426.35a.52.52,0,0,1-.44-.25c-4.85-8.67-2.89-18.84-2.8-19.27a.49.49,0,0,1,.58-.39.5.5,0,0,1,.4.59c0,.1-2,10.24,2.7,18.58a.5.5,0,0,1-.44.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.13,430.48a.49.49,0,0,1-.43-.24c-3.05-4.95-4.32-8.21-3.77-9.7a1.06,1.06,0,0,1,.6-.67.51.51,0,0,1,.63.32.49.49,0,0,1-.25.6c-.07.12-.86,1.61,3.64,8.93a.5.5,0,0,1-.16.69A.51.51,0,0,1,407.13,430.48Zm-3.28-9.66h0Zm0,0Zm0,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--hand-1--inject-54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.65,353.16s-22.68,27-29.49,32.4a103.73,103.73,0,0,1-12.94,8.85l-24.51,24.52s.68,3.4-6.12,7.49-20.43,8.85-23.83,10.21S53.9,455,53.9,455Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9,455.51a.52.52,0,0,1-.43-.24.5.5,0,0,1,.14-.66L191.35,352.76a.5.5,0,0,1,.68.73c-.93,1.1-22.79,27.05-29.56,32.46a107.27,107.27,0,0,1-12.94,8.87l-24.3,24.3c0,.95-.4,4.13-6.39,7.72-5.57,3.35-15.62,7.13-21,9.16-1.25.46-2.24.84-2.88,1.09-3.35,1.34-40.46,18.21-40.83,18.38A.52.52,0,0,1,53.9,455.51Zm134.57-99.38L58,452.6c10-4.53,33.84-15.35,36.56-16.44l2.89-1.1c5.38-2,15.38-5.78,20.87-9.07,6.35-3.81,5.9-6.94,5.89-7a.54.54,0,0,1,.14-.45l24.51-24.51L149,394a105.9,105.9,0,0,0,12.87-8.81C167.12,381,182.19,363.5,188.47,356.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.55,311.91c-2.38.72-11,.24-11,.24s-5.24-4-7.86-6.44-9.3-16.45-12.64-17.17-17.41,7.4-17.41,7.4-11.44-5-14.3-4.53-12.17,8.82-12.17,8.82-12.87-1.91-15.26,1.91-6.2,16-10,23.6-17.65,27.9-17.65,27.9l-1.9,2.62s2.86,1,11.68,5.49,22.89,26,22.89,26,19.55-9.06,30.52-14.07,19.79-16,22.18-20.51,6.44-8.82,11.44-12.87,14.31-5.73,16.46-8.59-1.44-7.15-1.44-7.15a34.73,34.73,0,0,0,3.82-2.39c1.19-1,6-3.57,6.44-6.43S226.94,311.2,224.55,311.91ZM187.83,334.8,192.36,321c1.91,1.43,10.26,4.53,10.26,4.53C197.13,326.93,187.83,334.8,187.83,334.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,388.24a.51.51,0,0,1-.42-.23c-.14-.21-14.09-21.4-22.7-25.82s-11.58-5.44-11.61-5.45A.5.5,0,0,1,104,356l1.91-2.62c.13-.19,13.85-20.32,17.6-27.83,1.88-3.75,3.78-8.68,5.46-13,1.8-4.65,3.35-8.66,4.58-10.63,2.37-3.8,13.69-2.42,15.52-2.17,1.55-1.37,9.45-8.32,12.24-8.79s12.42,3.63,14.36,4.47c2.22-1.27,14.25-8,17.54-7.33,2.09.45,4.84,4.76,8.5,10.79,1.75,2.89,3.41,5.62,4.37,6.5,2.36,2.14,6.91,5.69,7.72,6.32,1.16.06,8.54.4,10.64-.23h0a3.48,3.48,0,0,1,3.37.6,4,4,0,0,1,1.08,3.78c-.42,2.52-3.67,4.72-5.61,6-.43.29-.78.53-1,.71a31.41,31.41,0,0,1-3.38,2.15c.91,1.25,3,4.71,1.09,7.29-1.15,1.54-4,2.67-7.31,4s-6.77,2.69-9.23,4.68c-5.42,4.39-9.12,8.55-11.32,12.73S181,369,169.68,374.12c-10.84,4.95-30.32,14-30.52,14.07A.54.54,0,0,1,139,388.24ZM105.17,356c1.25.49,4.51,1.88,11.12,5.27,8.31,4.27,20.89,22.87,22.84,25.8,2.82-1.3,20.14-9.32,30.13-13.89,11.1-5.06,19.72-16,22-20.28s6-8.56,11.57-13c2.58-2.09,6.25-3.55,9.49-4.84,3-1.21,5.89-2.35,6.88-3.66,1.88-2.51-1.39-6.49-1.42-6.53a.52.52,0,0,1-.11-.41.49.49,0,0,1,.26-.35,35.48,35.48,0,0,0,3.74-2.34c.24-.19.61-.44,1.07-.75,1.69-1.15,4.84-3.28,5.18-5.38a3,3,0,0,0-.75-2.86,2.45,2.45,0,0,0-2.42-.39h0c-2.44.73-10.79.28-11.14.26a.56.56,0,0,1-.28-.1c-.05-.05-5.29-4.1-7.9-6.47-1.07-1-2.69-3.64-4.56-6.72-2.54-4.19-6-9.94-7.85-10.33-2.57-.57-13.18,5.11-17.05,7.34a.48.48,0,0,1-.45,0c-3.14-1.37-11.8-4.86-14-4.49s-9.35,6.41-11.91,8.7a.47.47,0,0,1-.41.12c-3.49-.51-12.95-1.22-14.76,1.68-1.18,1.89-2.79,6.05-4.5,10.46s-3.6,9.32-5.49,13.1c-3.79,7.58-17.54,27.76-17.68,28Zm119.38-44.12h0ZM187.83,335.3a.57.57,0,0,1-.28-.08.51.51,0,0,1-.19-.57l4.53-13.83a.47.47,0,0,1,.32-.32.51.51,0,0,1,.45.07c1.83,1.37,10.05,4.43,10.13,4.46a.5.5,0,0,1,0,1c-5.31,1.38-14.49,9.12-14.59,9.19A.47.47,0,0,1,187.83,335.3Zm4.81-13.55-3.8,11.58c2.51-2,8-6.21,12.28-7.86A75.45,75.45,0,0,1,192.64,321.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.14,316.46a.49.49,0,0,1-.49-.41c-.07-.43-.72-4.22-.22-5.73s7.93-9,9.42-10.45a.5.5,0,0,1,.71.71c-3.38,3.38-8.86,9.1-9.18,10.06s.06,4.15.26,5.24a.51.51,0,0,1-.41.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.77,321.23a.36.36,0,0,1-.14,0,.48.48,0,0,1-.33-.62l1.9-6.2a.51.51,0,0,1,.19-.26l26-18.6a.5.5,0,0,1,.7.12.49.49,0,0,1-.12.69l-25.85,18.5-1.86,6A.48.48,0,0,1,147.77,321.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.65,325.76h-.08a.5.5,0,0,1-.41-.57c.16-1,1.05-6.21,2.32-7.23s9-2.84,10.34-3.17c2.53-2.18,14-12,16.44-12,1,0,3.68,1.16,8.33,3.21,5.63,2.49,13.34,5.89,15.94,5.61a.5.5,0,0,1,.11,1c-2.87.31-10.09-2.88-16.45-5.69-3.49-1.54-7.09-3.13-7.93-3.13-1.6,0-10.59,7.24-15.88,11.8a.65.65,0,0,1-.22.11c-3.46.82-9.25,2.36-10,3s-1.58,4.21-2,6.6A.49.49,0,0,1,160.65,325.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.88,316.66a4.46,4.46,0,0,1-3.48-1.31c-.57-.66-.75-1.25-.52-1.76.42-.93,2-1,2.33-1h0a.5.5,0,0,1,.5.5.49.49,0,0,1-.49.5c-.58,0-1.33.18-1.43.4,0,.07,0,.29.36.69,1.51,1.73,5.07.71,6.41.33a.48.48,0,0,1,.61.34.49.49,0,0,1-.34.62A14.94,14.94,0,0,1,222.88,316.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.62,326a.5.5,0,0,1-.26-.93c.36-.21,8.92-5.11,16-.95a.49.49,0,0,1,.18.68.51.51,0,0,1-.69.18c-6.57-3.86-14.91.91-15,.95A.47.47,0,0,1,202.62,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.58,334.83a.5.5,0,0,1-.49-.42l-.24-1.43a29.89,29.89,0,0,0-2.1-5.11.49.49,0,0,1,0-.41.47.47,0,0,1,.29-.28l4.77-1.67a.5.5,0,1,1,.33.94l-4.23,1.49a27.31,27.31,0,0,1,1.94,4.87l.24,1.43a.51.51,0,0,1-.41.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.54,344.84a.45.45,0,0,1-.2,0,.51.51,0,0,1-.26-.67l4.3-9.53a.49.49,0,0,1,.66-.25.5.5,0,0,1,.25.66L184,344.54A.51.51,0,0,1,183.54,344.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.57,371.76s15-9.77,20.51-13.83,8.34-3.34,11.2-4.29S123.45,357,133,368.9s8.58,20.74,7.39,23.13-31.23,20.51-31.23,20.51-4.3-17.17-16.93-27.43S74.57,371.76,74.57,371.76Z",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.15,413a.58.58,0,0,1-.19,0,.51.51,0,0,1-.3-.34c0-.17-4.4-17.13-16.76-27.16s-17.54-13.28-17.59-13.31a.49.49,0,0,1-.24-.42.51.51,0,0,1,.23-.43c.15-.1,15.07-9.81,20.48-13.81a18.43,18.43,0,0,1,9-3.84,16.18,16.18,0,0,0,2.38-.52c3.4-1.14,17.94,3.78,27.25,15.42,9.73,12.16,8.68,21.21,7.45,23.66S112.49,411.1,109.4,413A.44.44,0,0,1,109.15,413ZM75.49,371.76c1.73,1.16,7,4.83,17,13,11.23,9.11,16,23.79,16.92,27,11.6-7,29.68-18.35,30.48-20,1.15-2.3,2.08-10.84-7.33-22.6-9.57-12-23.78-15.89-26.16-15.1a16.43,16.43,0,0,1-2.52.57,17.31,17.31,0,0,0-8.54,3.65C90.59,361.87,78.42,369.85,75.49,371.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.48,400.29s27.83-17,32.47-19.8,10-6.6,10-6.6,1.46-7.36,8.54-7.61,13.92,2.54,23.19,7.61,20.75,23.61,22,31,3.66,9.64,1.71,14.46-9.28,5.08-10.74,5.08-4.88,3.05-4.88,3.05l-52.24,34",
    style: {
      fill: "#61DAFB"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.51,462a.51.51,0,0,1-.42-.23.49.49,0,0,1,.15-.69l52.23-34c.54-.49,3.58-3.13,5.16-3.13,1.39,0,8.44-.23,10.28-4.76,1.21-3,.66-4.89-.26-8a47.6,47.6,0,0,1-1.48-6.18c-1.23-7.38-12.64-25.64-21.72-30.61-8.87-4.85-15.8-7.82-22.93-7.55-6.61.23-8.06,7.14-8.07,7.21a.51.51,0,0,1-.2.31c-.06,0-5.44,3.85-10,6.62S15,400.54,14.74,400.71a.49.49,0,0,1-.68-.16.5.5,0,0,1,.16-.69c.28-.17,27.89-17,32.47-19.8,4.14-2.49,8.92-5.83,9.83-6.47.31-1.22,2.25-7.57,9-7.81,7.37-.27,14.43,2.74,23.45,7.67,9.29,5.09,21,23.77,22.22,31.32a48.07,48.07,0,0,0,1.46,6.06c.91,3.11,1.57,5.36.22,8.68-2.07,5.13-9.69,5.39-11.2,5.39-.93,0-3.28,1.79-4.55,2.92l-52.3,34.06A.53.53,0,0,1,44.51,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.65,420.41a.5.5,0,0,1-.27-.08.49.49,0,0,1-.15-.69c4-6.19,2.3-7.76,2.29-7.77a.51.51,0,0,1-.07-.7.48.48,0,0,1,.68-.09c.26.19,2.43,2.1-2.06,9.1A.51.51,0,0,1,98.65,420.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.85,428.84a.54.54,0,0,1-.36-.14.5.5,0,0,1,0-.71,22,22,0,0,0,6.71-13.29.5.5,0,1,1,1,0c0,.3-.4,7.41-7,14A.49.49,0,0,1,90.85,428.84Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.072db5247297159367cfae50e7dc09af.svg";
export { ForwardRef as ReactComponent };